// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"2e9f7d6e","244":"963b05bc","333":"06e28d65","335":"463df6d0","423":"e922df0a","456":"51eb6a80","475":"9052f16d","521":"b2db23b2","621":"108dfe8b","631":"51721bea","674":"7e7dc5cd","800":"1d8b29b1","894":"760f5dd9"}[chunkId] + ".chunk.js";
};